import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import moment from "moment";
import { ref, computed } from "vue";
import { getData } from "@/services/axios";
import { useRoute, useRouter } from "vue-router/composables";
import { showSumHoursMinutesAndSeconds } from "@/services/common";

import { watch } from 'vue';
export default {
  __name: 'Detail',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var lessonResults = ref([]);
    var drillResults = ref([]);
    var student = ref({});
    var isLoading = ref(false);
    var localYearMonth = computed(function () {
      var _route$query$year_mon;

      return moment((_route$query$year_mon = route.query.year_month) !== null && _route$query$year_mon !== void 0 ? _route$query$year_mon : new Date()).format("YYYY年MM月");
    });

    var setStudentData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var students;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getData("students/".concat(route.query.student_id));

              case 3:
                students = _context.sent;

                if (students) {
                  student.value = students.items[0];
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function setStudentData() {
        return _ref.apply(this, arguments);
      };
    }();

    var setStudyResultData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _route$query$year_mon2, data;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                isLoading.value = true;
                _context2.next = 4;
                return getData("dekitus_study_results?student_id=".concat(route.query.student_id, "&year_month=").concat((_route$query$year_mon2 = route.query.year_month) !== null && _route$query$year_mon2 !== void 0 ? _route$query$year_mon2 : ""));

              case 4:
                data = _context2.sent;
                lessonResults.value = data.items.filter(function (v) {
                  return v.type.indexOf("授業") > -1;
                });
                drillResults.value = data.items.filter(function (v) {
                  return v.type.indexOf("授業") === -1;
                });
                isLoading.value = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                isLoading.value = false;
                console.log(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      return function setStudyResultData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var monthlyLessonSummary = computed(function () {
      if (lessonResults.value) {
        return showSumHoursMinutesAndSeconds(lessonResults.value.map(function (v) {
          return v.time;
        }));
      } else {
        return "";
      }
    });
    var monthlyDrillSummary = computed(function () {
      if (drillResults.value) {
        return showSumHoursMinutesAndSeconds(drillResults.value.map(function (v) {
          return v.time;
        }));
      } else {
        return "";
      }
    });

    var monthChange = function monthChange(mode) {
      if (!isLoading.value) {
        var _route$query$year_mon3;

        var date = moment((_route$query$year_mon3 = route.query.year_month) !== null && _route$query$year_mon3 !== void 0 ? _route$query$year_mon3 : new Date());

        if (mode === "add") {
          date.add(1, "months");
        } else if (mode === "sub") {
          date.subtract(1, "months");
        }

        router.push({
          query: Object.assign({}, route.query, {
            year_month: date.format("YYYY-MM")
          })
        });
      }
    };

    watch(function () {
      return route.query.year_month;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return setStudyResultData();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    setStudentData();
    setStudyResultData();
    return {
      __sfc: true,
      route: route,
      router: router,
      lessonResults: lessonResults,
      drillResults: drillResults,
      student: student,
      isLoading: isLoading,
      localYearMonth: localYearMonth,
      setStudentData: setStudentData,
      setStudyResultData: setStudyResultData,
      monthlyLessonSummary: monthlyLessonSummary,
      monthlyDrillSummary: monthlyDrillSummary,
      monthChange: monthChange
    };
  }
};